/* shah */
import React from 'react'

const RightIcon = () => {
    return (
        <svg id="SmallBoxSVG-right" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M80 4621 c-19 -10 -46 -33 -58 -52 -20 -29 -23 -44 -20 -96 3 -55 8
-67 38 -98 19 -19 50 -40 70 -45 48 -14 4852 -14 4900 0 20 5 51 26 70 45 30
31 35 43 38 98 3 52 0 67 -20 96 -12 19 -39 42 -58 52 -33 18 -119 19 -2480
19 -2361 0 -2447 -1 -2480 -19z"/>
                <path d="M1509 3336 c-38 -26 -69 -86 -69 -133 0 -38 35 -104 68 -128 27 -20
45 -20 1767 -23 1722 -2 1740 -2 1773 18 97 60 97 210 0 270 -33 20 -54 20
-1768 20 l-1735 0 -36 -24z"/>
                <path d="M72 2050 c-97 -60 -97 -210 0 -270 33 -20 56 -20 2488 -20 2432 0
2455 0 2488 20 97 60 97 210 0 270 -33 20 -56 20 -2488 20 -2432 0 -2455 0
-2488 -20z"/>
                <path d="M2747 786 c-48 -18 -76 -42 -93 -83 -33 -76 -1 -168 70 -202 42 -21
52 -21 1162 -21 1070 0 1121 1 1154 19 19 10 46 33 58 52 20 29 23 44 20 96
-3 55 -8 67 -38 98 -19 19 -50 40 -70 45 -22 6 -441 10 -1130 10 -898 -1
-1102 -3 -1133 -14z"/>
            </g>
        </svg>
    )
}

export default RightIcon